export const isValidAmount = (value: any): boolean => {
  if (!value) {
    return false;
  }

  const stringValue = value.toString();

  if (stringValue.includes("e") || stringValue.includes("E")) {
    return false;
  }

  const numValue = Number(stringValue);
  return !isNaN(numValue) && isFinite(numValue) && numValue > 0;
};

export const preventScientificNotationInput = (
  e: React.KeyboardEvent
): void => {
  if (e.key === "e" || e.key === "E") {
    e.preventDefault();
  }
};
